import React, {useState} from 'react'
import {connect} from "react-redux";

// components
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {GenericButton} from "../../../../components/buttons/customButtons";
import Loading from "../../../../components/loader/Loading";

// labels
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";

//services
import {scheduleHotelActivityService} from "../../../../jwt/_services/hotel/hotelScheduleService";


const ScheduleContent = props => {
    const {schedule: {label, id}, schedule, statePath, setShowFormModal} = props

    const [isDeleting, setIsDeleting] = useState(false);

    const onEdit = (data) => {
        props.setItem(statePath, data);
        props.setForm(statePath, true, false, false)
        setShowFormModal(showFormModal => !showFormModal);
    }

    const handleIsDeleting = () => setIsDeleting( isDeleting => !isDeleting);

    const onDelete = id => {
        handleIsDeleting()
        genericIndexedActions.delete(statePath, scheduleHotelActivityService, id, null, handleIsDeleting) // vincular la amenidad con el tipo de habitación
    }

    return  <>
        <div className={'module-menu-item'}>
            <Loading isLoading={isDeleting}/>
            <label className="module-menu-item-title">
                <h5>{label}</h5>
            </label>
            <div className="float-right">
                <GenericTableButton
                    toolTip={TT_EDIT}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={() => onEdit(schedule)}
                />
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_REMOVE}
                    icon={'fa-minus'}
                    permission={'delete'}
                    onClick={_ => onDelete(id)}
                />
            </div>
        </div>
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(ScheduleContent)